export default __webpack_public_path__ + "static/N0004-755e7a39ecc6b460d6e21215d64a30b2.png";